import {
  ADD_REMINDERS,
  FETCHING_REMINDERS,
  FETCHED_REMINDERS,
  PREPEND_REMINDER,
  CANCEL_REMINDER,
  COMPLETE_REMINDER,
  UPDATE_REMINDER,
} from '../constants';

interface RemindersState {
  list: Record<string, any[]>;
  fetching: boolean;
  fetched: Record<string, number>;
}

const initialState: RemindersState = {
  list: {},
  fetching: false,
  fetched: {},
};

export default function remindersReducer(
  state = initialState,
  { type, payload }: { type: string; payload?: any },
): RemindersState {
  switch (type) {
    case ADD_REMINDERS:
      return {
        ...state,
        list: { ...state.list, [String(payload.project_id)]: payload.list },
        fetching: false,
      };
    case FETCHING_REMINDERS:
      return { ...state, fetching: payload };
    case FETCHED_REMINDERS:
      return {
        ...state,
        fetched: { ...state.fetched, [String(payload.project_id)]: Date.now() },
      };
    case PREPEND_REMINDER: {
      const key = String(payload.project_id);
      const existing = state.list[key] ?? [];
      return {
        ...state,
        list: { ...state.list, [key]: [payload.reminder, ...existing] },
      };
    }
    case CANCEL_REMINDER: {
      const key = String(payload.project_id);
      const existing = state.list[key] ?? [];
      return {
        ...state,
        list: {
          ...state.list,
          [key]: existing.map((r) =>
            r.id === payload.reminder_id ? { ...r, status: 'canceled' } : r,
          ),
        },
      };
    }
    case COMPLETE_REMINDER: {
      const key = String(payload.project_id);
      const existing = state.list[key] ?? [];
      return {
        ...state,
        list: {
          ...state.list,
          [key]: existing.map((r) =>
            r.id === payload.reminder_id ? { ...r, status: 'sent' } : r,
          ),
        },
      };
    }
    case UPDATE_REMINDER: {
      const key = String(payload.project_id);
      const existing = state.list[key] ?? [];
      // Remove the old reminder and prepend the new one
      const without = existing.filter((r) => r.id !== payload.old_id);
      return {
        ...state,
        list: {
          ...state.list,
          [key]: [payload.reminder, ...without],
        },
      };
    }
    default:
      return state;
  }
}
